<script>
import MarkdownIt from 'markdown-it'
import mila from 'markdown-it-link-attributes'
import { defineComponent, h, onMounted, onUpdated, ref } from 'vue'

export default defineComponent({
  name: 'MarkdownBlock',
  props: {
    text: {
      type: String,
      default: ''
    },
    tag: {
      type: String,
      default: 'div'
    },
    inline: {
      type: Boolean,
      default: false
    },
    linksAttributes: {
      type: Object,
      default () {
        return {
          attrs: {
            target: '_blank',
            rel: 'noopener'
          }
        }
      }
    },
    breaks: {
      type: Boolean,
      default: false
    },
    html: {
      type: Boolean,
      default: false
    },
    langPrefix: {
      type: String,
      default: 'language-'
    },
    linkify: {
      type: Boolean,
      default: false
    },
    plugins: {
      type: Array,
      default: () => []
    },
    quotes: {
      type: String,
      default: '“”‘’'
    },
    typographer: {
      type: Boolean,
      default: true
    },
    xhtmlOut: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const md = ref()
    const renderMarkdown = () => {
      const markdown = new MarkdownIt()
        .use(mila, props.linksAttributes)
        .set({
          breaks: props.breaks,
          html: props.html,
          langPrefix: props.langPrefix,
          linkify: props.linkify,
          quotes: props.quotes,
          typographer: props.typographer,
          xhtmlOut: props.xhtmlOut
        })

      if (props.inline) {
        md.value = markdown.renderInline(props.text)
      } else {
        md.value = markdown.render(props.text)
      }
    }
    onMounted(() => renderMarkdown())
    onUpdated(() => renderMarkdown())
    return () => h(props.tag, { innerHTML: md.value })
  }
})
</script>
